import React from 'react';
import { Icon } from 'semantic-ui-react';
import { func, number } from 'prop-types';

import css from './DevicePermissionCheck.less';
import ModalDeniedPermisson from './ModalDeniedPermisson';

function DevicePermissionCheck({ cameraPermission, micPermission, onClose }) {
  return (
    <div className={css.container}>
      <div className={css.content}>
        <Icon loading name="spinner" />
        <div>Connecting...</div>
        <ModalDeniedPermisson
          cameraPermission={cameraPermission}
          micPermission={micPermission}
          onClose={onClose}
        />
      </div>
    </div>
  );
}

DevicePermissionCheck.propTypes = {
  cameraPermission: number,
  micPermission: number,
  onClose: func.isRequired,
};

DevicePermissionCheck.defaultProps = {
  cameraPermission: null,
  micPermission: null,
};

export default DevicePermissionCheck;
